import React, { useState } from "react";
import "./serverControll.css";
import Logo from "../../assets/logotipo - alfa tabelas.png";

export default function ServerControll() {
  const [ipAddress, setIpAddress] = useState("");

  const handleInputChange = (event) => {
    const input = event.target.value;
    const filteredInput = input.replace(/[^0-9.]/g, ""); // Remove caracteres que não sejam números ou pontos.
    setIpAddress(filteredInput);
  };

  const handleAction = (action) => {
    if (ipAddress) {
      if (action === "ligar") {
        alert("ligado");
      } else if (action === "desligar") {
        alert("desligado");
      } else if (action === "reiniciar") {
        alert("reiniciando");
      }
    } else {
      alert("Digite um endereço de IP válido");
    }
  };

  return (
    <div className="server-controll">
      <img src={Logo} alt="Logo ALfa Tabelas" />

      <h1>Gerenciamento do Servidor</h1>
      <div className="form-group">
        <label htmlFor="ipAddress">Endereço IP do Servidor:</label>
        <input
          type="text"
          id="ipAddress"
          value={ipAddress}
          onChange={handleInputChange}
          placeholder="Digite o número do endereço IP do servidor"
        />
        <div className="buttons">
          <button onClick={() => handleAction("ligar")}>Ligar</button>
          <button onClick={() => handleAction("desligar")}>Desligar</button>
          <button onClick={() => handleAction("reiniciar")}>Reiniciar</button>
          <button onClick={() => handleAction("backup")}>Backup</button>
        </div>
      </div>
    </div>
  );
}
